var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHospital(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.37 86.12H481V487H31.37V86.12Z",
    fill: "#E6FAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256.02 86.12H481V487H256.02V86.12Z",
    fill: "#CCF8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M421.09 256V487H90.96V256C90.96 247.72 97.68 241 105.96 241H330.5C330.67 240.99 330.83 240.97 331 240.97C331.17 240.97 331.33 240.99 331.5 241H406.09C414.37 241 421.09 247.72 421.09 256Z",
    fill: "#84EEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M421.09 256V487H256.02V241H330.5C330.67 240.99 330.83 240.97 331 240.97C331.17 240.97 331.33 240.99 331.5 241H406.09C414.37 241 421.09 247.72 421.09 256Z",
    fill: "#22E0E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.959 350.333H166V400.667H120.959V350.333Z",
    fill: "#005A96"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M196 350.333H241V400.667H196V350.333Z",
    fill: "#005A96"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M196 271H241V320.333H196V271Z",
    fill: "#005A96"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M271 271H316V320.333H271V271Z",
    fill: "#004071"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M196 430.667H241V482H196V430.667Z",
    fill: "#005A96"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M271 430.667H316V482H271V430.667Z",
    fill: "#004071"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M271 350.333H316V400.667H271V350.333Z",
    fill: "#004071"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M346 350.333H391.09V400.667H346V350.333Z",
    fill: "#004071"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M346 271H391.09V320.333H346V271Z",
    fill: "#004071"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M120.959 271H166V320.333H120.959V271Z",
    fill: "#005A96"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M120.959 430.667H166V482H120.959V430.667Z",
    fill: "#005A96"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M346 430.667H391.09V482H346V430.667Z",
    fill: "#004071"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M496.95 0H15C6.716 0 0 6.716 0 15V76.125C0 84.409 6.716 91.125 15 91.125H496.95C505.234 91.125 511.95 84.409 511.95 76.125V15C511.95 6.716 505.234 0 496.95 0Z",
    fill: "#22E0E0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M511.95 15V76.12C511.95 84.41 505.23 91.12 496.95 91.12H256.02V0H496.95C505.23 0 511.95 6.72 511.95 15Z",
    fill: "#22C7E0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M286.552 151.438H271.025V135.913C271.025 127.629 264.309 120.913 256.025 120.913C247.741 120.913 241.025 127.629 241.025 135.913V151.438H225.498C217.214 151.438 210.498 158.154 210.498 166.438C210.498 174.722 217.214 181.438 225.498 181.438H241.025V196.963C241.025 205.247 247.741 211.963 256.025 211.963C264.309 211.963 271.025 205.247 271.025 196.963V181.438H286.552C294.836 181.438 301.552 174.722 301.552 166.438C301.552 158.154 294.836 151.438 286.552 151.438Z",
    fill: "#F4425C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M301.55 166.44C301.55 174.72 294.84 181.44 286.55 181.44H271.02V196.96C271.02 205.25 264.31 211.96 256.02 211.96V120.91C264.31 120.91 271.02 127.63 271.02 135.91V151.44H286.55C294.84 151.44 301.55 158.15 301.55 166.44Z",
    fill: "#DD124C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M497 482H15.05C6.766 482 0.0500031 488.716 0.0500031 497C0.0500031 505.284 6.766 512 15.05 512H497C505.284 512 512 505.284 512 497C512 488.716 505.284 482 497 482Z",
    fill: "#84EEF9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M512 497C512 505.28 505.28 512 497 512H256.02V482H497C505.28 482 512 488.72 512 497Z",
    fill: "#22E0E0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.fbf55c2526cb37b51f17ce2a6dd64d53.svg";
export { ForwardRef as ReactComponent };